module.exports = __webpack_public_path__ + "static/media/crane3.eab77565.png";